<template>
  <a-layout-header class="header">
    <div class="logo">
      <MenuOutlined class="trigger" @click="$emit('toggle-collapsed')" />
      <img class="ml-3 mr-2" :src="`${publicPath}images/Deloitte-logo_white.jpg`" alt="logo" srcset="">
      <span class="vertical-line">|</span>
      <span class="home-title ml-3 mr-4">TechTDS</span>
    </div>

    <a-menu v-if="showHeader && currentUserRole != 1" theme="dark" mode="horizontal" :selectedKeys="[selectedHeader]">
      <template v-for="header in headers" :key="header.subName">
        <a-menu-item
          v-if="userModules?.indexOf(header.masterName) > -1"
          :key="header.subName"
          @click="$emit('goto-header', header)"
        >
          {{ header.name }}
        </a-menu-item>
      </template>
    </a-menu>

    <div class="notifi-block">
      <template v-if="currentUserRoles.length > 1">
        <a-select
          :value="currentUserRole"
          class="role-select"
          @change="$emit('role-change', $event)"
        >
          <a-select-option
            v-for="role in currentUserRoles"
            :key="role.RoleId"
            :value="role.RoleId"
          >
            {{ role.RoleName }}
          </a-select-option>
        </a-select>
      </template>

      <a-dropdown :trigger="['click']" class="user-dropdown" placement="bottomRight" overlayClassName="myclass app-topheader-overlay">
        <a class="ant-dropdown-link user-link" @click.prevent>
          <a-row>
            <a-col :span="7" class="text-right m-auto">
              <span class="user-avatar">
                <span class="user-avatar">{{ getThumbnailUsername(loggedinUserInfo?.userName) }}</span>
              </span>
            </a-col>
            <a-col :span="15" class="m-auto">
              <span>{{ loggedinUserInfo?.userName }}</span>
              <small v-if="loggedinUserInfo?.tenantName">{{ loggedinUserInfo?.tenantName }}</small>
              <DownOutlined class="profile-down-icon" />
            </a-col>
          </a-row>
        </a>
        <template #overlay>
          <a-menu class="logout-dropdown">
            <div v-if="userTenants && userTenants.length > 0" class="tenant-container" @click.stop >
              <a-input v-model:value="tenantSearch" placeholder="Search Tenant..." allow-clear class="tenant-search" />
                <div class="tenant-list">
                  <a-menu-item v-for="tenantUser in userTenants.filter(t =>
                    t.tenantName?.toLowerCase().includes(tenantSearch.toLowerCase()) || !tenantSearch)"
                    :key="tenantUser.tenantID" @click="confirmTenantChange(tenantUser.tenantID)"
                    :disabled="String(tenantUser.tenantID) === String(currentTenantId)" >
                    {{ tenantUser.tenantName }}
                  </a-menu-item>
                  <div v-if="userTenants.filter(t => !tenantSearch ||
                    t.tenantName.toLowerCase().includes(tenantSearch.toLowerCase())).length === 0"
                    class="no-tenant-found" >
                    No tenants found
                  </div>
                </div>
            </div>
            <a-menu-divider v-if="userTenants && userTenants.length > 0" />
            <a-menu-item key="logout" @click="$emit('logout')">
              <span class="logout-main">
                <span class="logout-left">Logout</span>
                <span class="logout-right material-symbols-outlined">logout</span>
              </span>
            </a-menu-item>
            </a-menu>
          </template>
      </a-dropdown>
    </div>
  </a-layout-header>

  <a-modal v-model:open="showTenantConfirm" title="Confirm Tenant Switch" :closable="false" :maskClosable="false" >
    <p>
      You are about to switch to a different tenant. Any unsaved changes may be lost. Do you want to proceed?
    </p>
    <template #footer>
      <a-button @click="cancelTenantChange">
        Cancel
      </a-button>
      <a-button type="primary" @click="proceedTenantChange">
        Proceed
      </a-button>
    </template>
  </a-modal>
</template>

<style>
.role-select {
  width: 120px !important;
}

.user-dropdown {
  display: inline-block !important;
}

.user-link {
  color: #fff !important;
}

.app-topheader-overlay {
  min-width: 230px !important;
}

.app-topheader-overlay .logout-dropdown {
  width: 230px;
}
.tenant-container {
  width: 250px;
  padding: 10px;
}

.tenant-search {
  margin-bottom: 8px;
  width : 90% !important;
}

.tenant-list {
  max-height: 170px;
  overflow-y: auto;
  border: 1px solid #f0f0f0;
  border-radius: 4px;
}

.tenant-list .ant-menu-item {
  margin: 0 !important;
}

.no-tenant-found {
  padding: 12px;
  text-align: center;
  color: #999;
}

.tenant-list::-webkit-scrollbar {
  width: 6px;
}

.tenant-list::-webkit-scrollbar-thumb {
  background: #d9d9d9;
  border-radius: 3px;
}
</style>

<script>
import { defineComponent } from 'vue'
import { MenuOutlined, DownOutlined } from '@ant-design/icons-vue'

export default defineComponent({
  name: 'AppTopHeader',
  components: {
    MenuOutlined,
    DownOutlined
  },
  props: {
    publicPath: {
      type: String,
      required: true
    },
    showHeader: {
      type: Boolean,
      required: true
    },
    currentUserRole: {
      type: [String, Number],
      default: ''
    },
    selectedHeader: {
      type: String,
      default: null
    },
    headers: {
      type: Array,
      required: true
    },
    userModules: {
      type: Array,
      required: true
    },
    currentUserRoles: {
      type: Array,
      required: true
    },
    loggedinUserInfo: {
      type: Object,
      required: true
    },
    userTenants: {
      type: Array,
      default: () => []
    },
    selectedTenantId: {
      type: Number,
      default: null
    }
  },
  data() {
  return {
    tenantSearch: '',
    filteredTenants: [],
    showTenantConfirm: false,
    pendingTenantId: null,
    currentTenantId: sessionStorage.getItem('tenantId'),
  }
},
mounted() {
  const timer = setInterval(() => {
    const tenantId = sessionStorage.getItem('tenantId');

    if (tenantId) {
      this.currentTenantId = tenantId;
      clearInterval(timer);
    }
  }, 100);
},
  emits: ['toggle-collapsed', 'goto-header', 'role-change', 'logout','tenant-change'],
  methods: {
    getThumbnailUsername(username) {
      if (!username) {
        return null
      }

      return username
        .split(' ')
        .map(word => word.charAt(0))
        .join('')
        .toUpperCase()
    },

    confirmTenantChange(tenantId) {
    this.pendingTenantId = tenantId;
    this.showTenantConfirm = true;
    },

    proceedTenantChange() {
    this.showTenantConfirm = false;
    this.$emit('tenant-change', this.pendingTenantId);
    this.pendingTenantId = null;
    },

    cancelTenantChange() {
    this.showTenantConfirm = false;
    this.pendingTenantId = null;
    }
  }
})
</script>
